import styled from '@emotion/styled';
import { Button } from '@mui/material';

import { font } from '../Font/Font.styles';

export const IconContainer = styled.div`
  padding-bottom: var(--spacing-24);
`;
export const ContactInfoList = styled.ul`
  display: flex;
  flex-direction: row;
  color: var(--color-black);
  padding: 0;
  margin: 0;
  padding-bottom: var(--spacing-24);
  list-style-type: none;
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;
export const ContactInfoText = styled.li`
  color: var(--color-neutral-70);

  ::after {
    content: '·';
    height: auto;
    width: auto;
    padding: var(--spacing-16);
    color: var(--color-neutral-70);
  }
  :last-child::after {
    content: none;
  }
  @media (max-width: 768px) {
    padding-bottom: var(--spacing-8);

    ::after {
      content: none;
    }
  }

  span {
    ${font('body-md')};
  }
`;
export const ListItem = styled.li`
  margin: var(--spacing-8);
  a:link,
  a:active,
  a:visited {
    ${font('body-lg')};
    text-decoration: none;
    color: var(--color-black);
    position: relative;
  }

  @media (min-width: 769px) {
    a::before {
      content: '';
      position: absolute;
      display: block;
      width: 100%;
      height: 1px;
      bottom: 0;
      left: 0;
      background-color: var(--color-black);
      transform: scaleX(1);
      transition: transform 0.3s ease;
    }
  }
  @media (max-width: 768px) {
    a:link,
    a:active,
    a:visited {
      text-decoration: underline;
    }
  }

  a:hover::before {
    transform: scaleX(0);
  }

  span {
    ${font('body-lg')};
  }
`;

export const CopyRight = styled.p`
  ${font('body-lg')};
  display: inline-block;
  color: var(--color-neutral-70);
`;

export const CookieSettingButton = styled(Button)`
  text-transform: none;
  background-color: var(--color-white);
  color: var(--color-black);
  margin: var(--spacing-8) var(--spacing-8) var(--spacing-24);

  svg {
    margin-right: var(--spacing-8);
  }

  &:hover {
    background-color: var(--color-neutral-20);
  }
`;
export const LogosWrapperDiv = styled.div`
  border-color: #cfcfcf;
  border-width: 1px;
  border-top-style: solid;
  border-bottom-style: solid;
  padding-block: var(--spacing-32);
  margin-bottom: var(--spacing-32);
  display: flex;
  align-items: center;
  gap: var(--spacing-16);
  justify-content: center;
  flex-wrap: wrap;
  user-select: none;

  img {
    height: 32px;

    &.trustly {
      height: 64px;
    }

    &.swish {
      height: 56px;
    }
  }
`;
